// extracted by mini-css-extract-plugin
module.exports = {"documentControlPanel":"documentControlPanel__P8Pb4","left":"left__MLJcb","center":"center__PK6pT","right":"right__XpuHz","select":"select__Cwv6P"};